import styled from 'styled-components';

export default styled.div`
  && {
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 75px 0;
    .icon {
      color: rgba(193, 225, 141, 1);
      font-size: 70px;
      margin-bottom: 50px;
    }
    > p {
      color: rgba(193, 225, 141, 1);
      margin-bottom: 50px;
    }
  }
`;
